(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["seravni-halloween-sale"] && !Shopify.designMode) return;
  try {
    class SeravniSale extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.endsAt = Date.parse(this.dataset.endsAt);
      this.clock = this.querySelector('[data-sale-clock]');
      this.units = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-sale-${unit}]`));
      if (!Number.isFinite(this.endsAt) || !this.clock || this.units.some(unit => !unit)) {
        this.hidden = true;
        console.error('The monitor sale deadline or countdown markup is invalid.');
        return;
      }
      this.controller = new AbortController();
      const update = () => this.updateCountdown();
      document.addEventListener('visibilitychange', update, { signal: this.controller.signal });
      if (this.updateCountdown()) {
        this.querySelector('time').classList.add('visually-hidden');
        this.clock.hidden = false;
        this.interval = setInterval(update, 1000);
      }
    }

    updateCountdown() {
      const remaining = Math.ceil((this.endsAt - Date.now()) / 1000);
      if (remaining <= 0) {
        this.hidden = true;
        this.disconnectedCallback();
        return false;
      }
      const values = [
        Math.floor(remaining / 86400),
        Math.floor(remaining / 3600) % 24,
        Math.floor(remaining / 60) % 60,
        remaining % 60,
      ];
      this.units.forEach((unit, index) => { unit.textContent = String(values[index]).padStart(2, '0'); });
      return true;
    }

    disconnectedCallback() {
      clearInterval(this.interval);
      this.controller?.abort();
    }
  }

  if (!customElements.get('seravni-sale')) customElements.define('seravni-sale', SeravniSale);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["seravni-monitor-bundle"] && !Shopify.designMode) return;
  try {
    class SeravniMonitorBundle extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      customElements.whenDefined('quantity-selector-component').then(() => {
        if (signal.aborted || !this.isConnected) return;
        const options = this.querySelector('[data-bundle-options]');
        if (!options) return;
        const selector = this.querySelector('quantity-selector-component');
        const choices = [...this.querySelectorAll('[data-bundle-choice]')];
        if (!selector?.getValue || !selector.setValue || !selector.onQuantityChange || choices.length !== 2) {
          throw new Error('The native quantity selector or pair choices are missing.');
        }
        const selected = choices.find(choice => choice.value === selector.getValue());
        if (!selected) throw new Error('The native quantity does not match an available set.');
        choices.forEach(choice => { choice.checked = choice === selected; });
        this.addEventListener('change', event => {
          const choice = event.target;
          if (!(choice instanceof HTMLInputElement) || !choices.includes(choice)) return;
          if (choice.disabled || !['1', '2'].includes(choice.value)) {
            this.showError(new Error('The requested monitor set is unavailable.'));
            return;
          }
          selector.setValue(choice.value);
          selector.onQuantityChange();
          selector.updateButtonStates();
        }, { signal });
        options.hidden = false;
        this.dataset.ready = 'true';
      }).catch(error => this.showError(error));
    }

    showError(error) {
      console.error('[monitor-bundle] Unable to select a set:', error);
      this.controller?.abort();
      delete this.dataset.ready;
      const options = this.querySelector('[data-bundle-options]');
      if (options) options.hidden = true;
      const notice = this.querySelector('[data-bundle-error]');
      if (notice) notice.hidden = false;
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  }

  if (!customElements.get('seravni-monitor-bundle')) customElements.define('seravni-monitor-bundle', SeravniMonitorBundle);
  } catch(e) { console.error(e); }
})();

})();
